export default "__VITE_ASSET__DPiT_l04__"